var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading'),_c('popup'),_c('router-view'),_c('lanhu-dialog',{ref:"dialog",attrs:{"showCancelButton":_vm.showCancelButton,"content":_vm.dialogText,"handleConfirm":_vm.goUpdate,"confirmButtonText":_vm.confirmButtonText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }